import {apiService, getAuthValues, setAuthHeader} from "./api";
import {CompanyInfo, User} from "../models";

async function checkCompany(): Promise<CompanyInfo[]> {
    let response;
    const {token} = getAuthValues();
    setAuthHeader(token!);
    response = await apiService.get<CompanyInfo[]>(`/company?type=getUserCompany`);
    return response.data;
}

async function getInfos(): Promise<User> {
    const {token} = getAuthValues();
    let res;
    setAuthHeader(token!);
    res = await apiService.get<User>("/company?type=getCurrentUser");
    return res.data;
}

async function fetchCountryCode() {
    let res: any;
    try {
        res = await apiService.get(`/public?type=getCountryCodeAPIUrl`);
        if (res.status === 200) {
            const countryRes = await fetch(res.data.url);
            const countryResData = await countryRes.json();
            return countryResData.countryCode;
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error fetching country code", error);
    }
}

export {checkCompany, fetchCountryCode, getInfos};
